import {CustomDownloadFile} from 'common/HelperFunctions'

import {AttendanceReportExportPayload} from './attendanceReportExportTypes'

function escapeCsvCell(value: string): string {
  const s = String(value ?? '')
  if (/[",\n\r]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`
  }
  return s
}

export function attendanceRecordsToCsv(columns: string[], rows: Record<string, string>[]): string {
  const header = columns.map(escapeCsvCell).join(',')
  const body = rows.map((row) => columns.map((col) => escapeCsvCell(row[col] ?? '')).join(','))
  return [header, ...body].join('\r\n')
}

export function attendanceReportToStructuredCsv(payload: AttendanceReportExportPayload): string {
  const {title, metaLines = [], summaryLines = [], columns, rows} = payload
  const sections: string[] = []

  sections.push(escapeCsvCell(title))

  for (const line of metaLines) {
    if (line.trim()) sections.push(escapeCsvCell(line))
  }

  if (summaryLines.length > 0) {
    sections.push('')
    for (const line of summaryLines) {
      if (line.trim()) sections.push(escapeCsvCell(line))
    }
  }

  if (payload.chartImageDataUrl) {
    sections.push('')
    sections.push(
      escapeCsvCell('Summary chart: download the PDF export for the attendance ring and bar chart.')
    )
  }

  sections.push('')
  sections.push(attendanceRecordsToCsv(columns, rows))

  return sections.join('\r\n')
}

/** UTF-8 BOM so Excel opens encoding correctly. */
export function downloadAttendanceReportSpreadsheet(payload: AttendanceReportExportPayload): void {
  const {columns, rows, filename} = payload
  if (!columns.length || !rows.length) return

  const baseName = filename.replace(/\.(csv|xlsx)$/i, '')
  const csv = `\uFEFF${attendanceReportToStructuredCsv({...payload, filename: baseName})}`
  CustomDownloadFile(csv, `${baseName}.csv`, 'text/csv;charset=utf-8;')
}

export function downloadAttendanceRecordsCsv(
  columns: string[],
  rows: Record<string, string>[],
  filename = 'attendance-records.csv'
): void {
  const csv = attendanceRecordsToCsv(columns, rows)
  CustomDownloadFile(`\uFEFF${csv}`, filename, 'text/csv;charset=utf-8;')
}
